import { RouteConfigProvider } from '@/context/route-config';
import PersonalInformationForm, { type PersonalInformationRouteConfig } from '@/features/onboarding/personal-information/components/form';
import PersonalInformationLayout from '@/features/onboarding/personal-information/layout';

const ROUTE_CONFIG = {
  fcaQuestionnaire: '/onboarding/fca-questionnaire',
  forbiddenJurisdiction: '/onboarding/personal-information/forbidden-jurisdiction',
  next: '/onboarding/verification',
} satisfies PersonalInformationRouteConfig;

const PersonalInformationPage = () => {
  return (
    <PersonalInformationLayout>
      <RouteConfigProvider config={ROUTE_CONFIG}>
        <PersonalInformationForm />
      </RouteConfigProvider>
    </PersonalInformationLayout>
  );
};
PersonalInformationPage.displayName = 'PersonalInformationPage';

export default PersonalInformationPage;
